import CurrentUserDrawer from "@/components/CurrentUserDrawer";
import { Check, Close, Verified } from "@mui/icons-material";
import {
  AppBar,
  CircularProgress,
  Box,
  Button,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { currentUser } from "@/App";

export default function PageAppBar() {
  const navigate = useNavigate();

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{ bgcolor: "rgba(19,19,19,.9)" }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Box>
          <IconButton
            onClick={() => navigate(`/${currentUser?.key}`)}
            sx={{ p: 0 }}
          >
            <Close />
          </IconButton>
        </Box>

        <CurrentUserDrawer />
      </Toolbar>
    </AppBar>
  );
}
